import { Injectable } from "@angular/core";
import { ServiceArea } from "app/models/serviceArea";
import * as _ from "lodash";

import { URLSearchParams } from '@angular/http'
import { Observable } from "rxjs";
import { HttpBackendService } from "./http-backend.service";

@Injectable()
export class ServiceAreaService {
    
    constructor(
        private _http: HttpBackendService
    ) { }

    public getServiceAreas(): Observable<ServiceArea[]> {
        let params = new URLSearchParams;
        params.append('$filter', "IsDeleted eq false");
        params.append('$select', "Id,Name");

        return this._http.get("/api/odata/serviceAreas", params, true)
                .map(resp => {
                    
                    var serviceAreas = _.map(resp.json().value, function (value) {
                        return ServiceAreaService.convertServiceAreaDTO2Object(value);
                      });
              
                    return serviceAreas;
                });
    }

    
}

export namespace ServiceAreaService {
    export function convertServiceAreaDTO2Object(dto : any, serviceArea : ServiceArea = new ServiceArea()): ServiceArea {
        
        serviceArea.id = dto.Id;
        serviceArea.name = dto.Name;
        serviceArea.longitude = dto.Longitude;
        serviceArea.latitude = dto.Latitude;
        serviceArea.isDeleted = dto.IsDeleted;
        
        if(dto.ParentServiceArea != null)
        {
            serviceArea.parent = convertServiceAreaDTO2Object(dto.ParentServiceArea);
        }

        if(dto.ChildServiceAreas != null)
        {
            serviceArea.children = _.map(dto.ChildServiceAreas, function(value) {
                return convertServiceAreaDTO2Object(value);
            });
        }

        return serviceArea;
    }
}


// WEBPACK FOOTER //
// /app/SPA/src/app/services/serviceArea.service.ts